<template>
  <v-row>
    <v-col cols="12">
      <iframe
        src="https://crm.iotech.my.id/#/dashboard/external/approval-finance?hrId=84"
        width="100%"
        height="800"
        frameborder="0"
      />
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "approval-plan-sales",
};
</script>

<style></style>
